





















































































































































































































































































import { Component, Vue, Mixins, Prop } from 'vue-property-decorator';
import jQuery from 'jquery';
@Component({
	name: 'OldClaimsFormSingle',
	components: {},
})
export default class OldClaimsFormSingle extends Vue {
	@Prop() public claim: any;

	private created() {
		console.log('claim', this.claim);
	}
	private copyText() {
		const copyText = jQuery('#webId');

		const el = document.createElement('textarea');
		el.value = copyText.text();
		el.setAttribute('readonly', '');
		el.style.position = 'absolute';
		el.style.left = '-9999px';
		document.body.appendChild(el);
		el.select();
		document.execCommand('copy');
		document.body.removeChild(el);
	}
}
